import { IApplicationState } from '../../types/redux';

export const selectInfoForTgb = (state: IApplicationState) => state.infoForTgb;
